/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"

import router from '@/router'
import { reject } from "core-js/fn/promise"

export default {
    
    // JWT
    loginJWT({ commit }, payload) {
      return new Promise((resolve,reject) => {
        jwt.login(payload.userDetails.email, payload.userDetails.password)
          .then(response => {
            // If there's user data in response
            if(!response.data.existeError) {
              // Navigate User to homepage
              
              if(_.size(response.data.data) > 0){
                  localStorage.setItem("accessToken", response.data.data.accessToken)
                  
                  // Update user details
                  commit('UPDATE_USER_INFO', response.data.data, {root: true});
                  // Set bearer token in axios
                  commit("SET_BEARER", response.data.data.accessToken);

                  resolve(response.data.data.carrito)
                
                // router.push(router.currentRoute.query.to || '/')
              }
              else{
                reject({message: "Correo o contraseña incorrecta."})
              }
            }else {
              reject({ message: response.data.mensaje })
            }
          })
          .catch(error => { reject(error) })
      })
    },
    registerUserJWT({ commit }, payload) {

      return new Promise((resolve,reject) => {

        // Check confirm password
        if(payload.userDetails.contrasenia !== payload.userDetails.confirm_contrasenia) {
          reject({message: "La contraseña no coincide. Inténtalo de nuevo."})
        }

        jwt.registerUser(payload.userDetails)
          .then(response => {
            if(response.data._id_registro != 0 && response.data.existeError != true){
             
            }else{
              // si hay problemas por lo general es por validacion
              reject(response.data.mensaje)
            }
            resolve(response)
          })
          .catch(error => { reject(error) })
      })
    },
    recoverUserJWT({ commit }, payload) {

      return new Promise((resolve,reject) => {

        // Check confirm password
        if(payload.userDetails.email === '') {
          reject({message: "Email requerido."})
        }

        jwt.recoverUserJWT(payload.userDetails)
          .then(response => {
            if(response.data._id_registro != 0 && response.data.existeError != true){
             
            }else{
              // si hay problemas por lo general es por validacion
              reject(response.data.mensaje)
            }
            resolve(response)
          })
          .catch(error => { reject(error) })
      })
    },
    recoverUserConfirmJWT({ commit }, payload) {

      return new Promise((resolve,reject) => {

        // Check confirm password
        if(payload.userDetails.contrasenia !== payload.userDetails.confirm_contrasenia) {
          reject({message: "La contraseña no coincide. Inténtalo de nuevo."})
        }

        jwt.recoverUserConfirmJWT(payload.userDetails)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => { reject(error) })
      })
    },
    fetchAccessToken() {
      return new Promise((resolve) => {
        jwt.refreshToken().then(response => { resolve(response) })
      })
    },
    verificarHash({ commit }, payload) {
      return new Promise((resolve) => {
        jwt.verificarHash(payload)
        .then(response  =>  resolve(response.data) )
        .catch( error   => reject(error))
        })
    }
}
